"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adsUITokens = exports.TokenValue = void 0;
/**
 * Token value types, used to define the type of the token value
 *
 * @public
 */
var TokenValue;
(function (TokenValue) {
    TokenValue["string"] = "string";
    TokenValue["number"] = "number";
})(TokenValue || (exports.TokenValue = TokenValue = {}));
/**
 * List of custom tokens for the AdsUI Kit components that dont exist in fluentui
 * To add new token, make sure you add it to the AdsUITokens object
 * this object is being used to define the type of the AdsUITokens dynamically
 *
 * @private
 * */
exports.adsUITokens = {
    // Global Colors
    adsui_colorBackgroundDefault: TokenValue.string,
    adsui_colorBackgroundFilled: TokenValue.string,
    adsui_colorBackgroundElevated: TokenValue.string,
    // Radius
    adsui_radiusSmall: TokenValue.string,
    adsui_radiusMedium: TokenValue.string,
    adsui_radiusLarge: TokenValue.string,
    adsui_radiusXLarge: TokenValue.string,
    // Spacing
    adsui_spacingXXS: TokenValue.string,
    adsui_spacingXS: TokenValue.string,
    adsui_spacingSNudge: TokenValue.string,
    adsui_spacingS: TokenValue.string,
    adsui_spacingMNudge: TokenValue.string,
    adsui_spacingM: TokenValue.string,
    adsui_spacingL: TokenValue.string,
    adsui_spacingXL: TokenValue.string,
    adsui_spacingXXL: TokenValue.string,
    adsui_spacingXXXL: TokenValue.string,
    // Fonts
    adsui_typographyCaption2: TokenValue.string,
    adsui_typographyCaption2Strong: TokenValue.string,
    adsui_typographyCaption1: TokenValue.string,
    adsui_typographyCaption1Strong: TokenValue.string,
    adsui_typographyCaption1Stronger: TokenValue.string,
    adsui_typographyBody1: TokenValue.string,
    adsui_typographyBody1Strong: TokenValue.string,
    adsui_typographyBody1Stronger: TokenValue.string,
    adsui_typographyBody2: TokenValue.string,
    adsui_typographySubtitle2: TokenValue.string,
    adsui_typographySubtitle2Stronger: TokenValue.string,
    adsui_typographySubtitle1: TokenValue.string,
    adsui_typographyTitle3: TokenValue.string,
    adsui_typographyTitle2: TokenValue.string,
    adsui_typographyTitle1: TokenValue.string,
    adsui_typographyLargeTitle: TokenValue.string,
    adsui_typographyDisplay: TokenValue.string,
    adsui_typographyPageTitle: TokenValue.string,
    adsui_typographyPageSubheader: TokenValue.string,
    adsui_typographySectionTitle: TokenValue.string,
    adsui_typographySectionSubheader: TokenValue.string,
};
